import { useMemo } from 'react';

import { useParams } from 'react-router';

import { Flex } from '@chakra-ui/react';

import type { MergePurgeView } from '@annotations/mergePurgeView';

import RedirectTo404 from '@/app/components/redirects/redirect-404';

import { MergePurgeProvider } from './context/merge-purge.provider';
import MergePurgeBody from './merge-purge-body';
import MergePurgeHeader from './merge-purge-header';
import MergePurgeSidebar from './merge-purge-sidebar';

export default function MergePurgeReport() {
  const params = useParams<{ mailingId: string; view: MergePurgeView }>();

  const { isInvalidMailingId, mailingId, view } = useMemo(() => {
    const parsed = Number(params.mailingId);

    return {
      isInvalidMailingId: !Number.isFinite(parsed),
      mailingId: parsed,
      view: params.view ?? 'summary',
    };
  }, [params]);

  if (isInvalidMailingId) {
    return <RedirectTo404 />;
  }

  return (
    <MergePurgeProvider>
      <Flex
        direction="column"
        flexGrow={1}>
        <MergePurgeHeader view={view} />
        <Flex flexGrow={1}>
          <MergePurgeSidebar view={view} />
          <MergePurgeBody
            mailingId={mailingId}
            view={view}
          />
        </Flex>
      </Flex>
    </MergePurgeProvider>
  );
}
